<div class="panel-matrix" *ngIf="charts$ | async as charts">
  <div
    class="panel-matrix__header"
    appAccountColorBackground
    #backgroundDirective="appAccountColorBackground"
    [colorName]="panelDef?.color"
  >
    <span
      *ngIf="!ui.editMode; else editModeTitle"
      class="panel-matrix__header__title"
      [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
    >
      {{ panelDef.title }}
    </span>
    <ng-template #editModeTitle>
      <div class="panel-matrix__header__title-edit">
        <div class="flex items-center flex-auto" *ngIf="ui.editMode">
          <app-form-field [fieldDef]="titleFieldDef" [model]="model" (onUpdate)="update($event)"></app-form-field>
        </div>
      </div>
    </ng-template>
    <div class="panel-matrix__header__actions" *ngIf="!readonly">
      <button
        mat-icon-button
        type="button"
        *ngIf="!ui.editMode"
        [matMenuTriggerFor]="moreMenu"
        [appAuthorize]="canEditDeal()"
        denyAction="disable"
      >
        <mat-icon
          class="icon-size-20"
          svgIcon="more_vert"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        ></mat-icon>
      </button>
      <mat-menu #moreMenu>
        <button
          mat-menu-item
          (click)="toggleEditMode()"
          type="button"
          [appAuthorize]="canEditDeal()"
          denyAction="disable"
        >
          <mat-icon svgIcon="edit"></mat-icon>
          Edit Chart
        </button>
        <button mat-menu-item [matMenuTriggerFor]="toggleLabelMenu" type="button">
          <mat-icon [svgIcon]="'color_lens'"></mat-icon>
          Heading Color
        </button>
        <mat-menu class="mailbox-details-toggle-label-menu-panel" #toggleLabelMenu="matMenu">
          <div
            mat-menu-item
            class="gap-2"
            *ngFor="let color of accountColors$ | async"
            (click)="selectHeaderColor(color.name)"
          >
            <ts-color-bubble [hexColor]="color.hex_value"></ts-color-bubble>
            {{ color.label }}
          </div>
        </mat-menu>
      </mat-menu>
      <div class="panel-matrix__header__actions__layout" *ngIf="ui.editMode">
        <button mat-icon-button type="button" matTooltip="Cancel" (click)="cancelEdits()">
          <mat-icon
            svgIcon="cancel"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <button mat-icon-button type="button" matTooltip="Save" (click)="saveLayout()">
          <mat-icon
            svgIcon="save"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div>
    <ng-container *ngIf="!ui.editMode">
      <ng-container *ngIf="!!panelDef.meta.chartId && timeSeriesFields$ | async as chartFields">
        <time-series-chart
          [chart]="chart"
          [timeSeriesFields]="chartFields"
          panelLayout="true"
          [panelOptions]="chartPanelOptions"
          [editPermission]="NewPermission.DEALS_EDIT"
        ></time-series-chart>
      </ng-container>
    </ng-container>

    <div class="p-8 w-full max-w-200 overflow-auto" *ngIf="ui.editMode">
      <ng-container *ngIf="ui.editMode && charts.length > 0">
        <form [formGroup]="chartForm" class="flex flex-row flex-wrap gap-x-3">
          <mat-form-field class="w-6/12 md:w-100 lg:w-100">
            <mat-label>Chart</mat-label>
            <mat-select [formControlName]="'chartId'">
              <mat-option *ngFor="let chart of charts" [value]="chart.id">{{ chart.title }}</mat-option>
            </mat-select>
            <mat-error *ngIf="chartForm.get('chartId').hasError('required')"> Chart is required</mat-error>
          </mat-form-field>

          <mat-form-field class="w-5/12 md:w-100">
            <mat-label>Default tab</mat-label>
            <mat-select [formControlName]="'activeTab'">
              <mat-option value="0">Chart</mat-option>
              <mat-option value="1">Table</mat-option>
            </mat-select>
            <mat-error *ngIf="chartForm.get('activeTab').hasError('required')"> Tab is required</mat-error>
          </mat-form-field>

          <mat-form-field class="w-6/12 md:w-100 lg:w-100">
            <mat-label>Start date</mat-label>
            <input
              matInput
              [matDatepicker]="startDatePicker"
              [formControlName]="'startDate'"
              [placeholder]="'Start Date'"
            />
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>

            <mat-error *ngIf="chartForm.get('startDate').hasError('required')"> Date is required</mat-error>
          </mat-form-field>

          <mat-form-field class="w-5/12 md:w-100">
            <mat-label>End date</mat-label>
            <input matInput [matDatepicker]="endDatePicker" [formControlName]="'endDate'" [placeholder]="'End Date'" />
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>

            <mat-error *ngIf="chartForm.get('endDate').hasError('required')"> Date is required</mat-error>
          </mat-form-field>
        </form>
      </ng-container>

      <ng-container *ngIf="ui.editMode && (!charts || charts?.length === 0)">
        <div class="">
          <div class="text-center">
            <h1 class="text-3xl font-semibold mb-3">No Charts Available</h1>
            <p class="font-bold text-primary">Before proceeding, you need to create a chart.</p>
            <p class="text-gray-600 mt-3 mb-2">To create a chart:</p>
            <ul class="text-center list-none ml-6">
              <li>Access the <span class="text-blue-500">Insights Tab</span>.</li>
              <li>Click on the <span class="text-blue-500">Analytics</span> menu option on the left.</li>
              <li>Click on the <span class="text-blue-500">New Chart</span> button on the right.</li>
            </ul>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="panel-matrix__body" *ngIf="!chart && !ui.editMode">
    <div class="panel-matrix__body__empty flex flex-col items-center justify-center h-full">
      <mat-icon class="icon-size-40">table_chart</mat-icon>
      <p class="text-2xl text-secondary font-medium mt-4">Please, select an existing chart</p>
      <p class="text-sm text-secondary cursor-pointer mt-2" (click)="toggleEditMode()" [appAuthorize]="canEditDeal()">
        <span class="font-bold text-primary">Click here</span> to select a chart.
      </p>
    </div>
  </div>
</div>
